import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "icon"]

  connect() {
    // Close dropdown when clicking outside
    this.boundCloseOnOutsideClick = this.closeOnOutsideClick.bind(this)
  }

  disconnect() {
    document.removeEventListener('click', this.boundCloseOnOutsideClick)
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()

    const isOpen = this.menuTarget.classList.contains('is-open')

    if (isOpen) {
      this.close()
    } else {
      this.open()
    }
  }

  open() {
    this.menuTarget.classList.add('is-open')
    this.iconTarget.classList.remove('fa-bars')
    this.iconTarget.classList.add('fa-times')
    // Add listener after a small delay to avoid immediate closing
    setTimeout(() => {
      document.addEventListener('click', this.boundCloseOnOutsideClick)
    }, 10)
  }

  close() {
    this.menuTarget.classList.remove('is-open')
    this.iconTarget.classList.remove('fa-times')
    this.iconTarget.classList.add('fa-bars')
    document.removeEventListener('click', this.boundCloseOnOutsideClick)
  }

  closeOnOutsideClick(event) {
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }
}
